<mat-form-field class="menu-filter">
  <mat-label>Select Location Set Type</mat-label>
  <mat-select
    [attr.data-testid]="'location_set_type_select'"
    [formControl]="locationSetTypeCtrl"
    [placeholder]="placeholderText"
    >
    @for (locationSetType of locationSetTypesList; track locationSetType) {
      <mat-option
        [value]="locationSetType"
        [attr.data-testid]="locationSetType.name + '_option'"
        >
        {{ locationSetType.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
